<template>
  <div class="home">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-2 sdbr">
          <Sidebar />
        </div>
        <div class="col-sm-10 txt-grey">
          <div class="row py-2">
            <Timeframe v-on:timeFrameEmit="dateChanged" :filter="filterObj" />
          </div>
          <div class="row p-4">
            <Summary :start="startDt" :end="endDt" :day="day" />
          </div>
          <div
            class="row shdw p-3 m-3 d-flex justify-content-end"
            v-if="showHist"
          >
            <div class="col-sm-3">
              <Paramdrpdwn v-on:sendParam="setChartData" />
            </div>
            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-12 text-center">
                  <h3>Usage History</h3>
                </div>
              </div>
              <Userchart :data="chartData" :param="param" />
            </div>
          </div>
          <div class="row mt-5">
            <div class="offset-md-1"></div>
            <div
              class="col-sm-12 col-md-4 border shdw brdrad py-2 text-white bg-top"
            >
              <div class="row">
                <div class="col-sm-12 text-center txt-grey py-4 text-white">
                  <h4>Top Users</h4>
                </div>
                <div class="col-sm-12 text-right pb-2 user-cnt">
                  <span class="h3">{{ allUserCnt }}</span> active users
                  {{ day }}.
                </div>
                <table class="table table-striped text-center">
                  <thead>
                    <tr>
                      <th scope="col">User</th>
                      <th scope="col">Total Calls</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="topUser in mostApiCalls"
                      v-bind:key="topUser.key"
                    >
                      <td class="cap" @click="navigate(topUser.key)">
                        {{ topUser.name }}
                      </td>
                      <td>{{ topUser.total }}</td>
                    </tr>
                  </tbody>
                </table>
                <div
                  class="col-sm-12 btn btn-sm text-center"
                  @click="getDetail('Total')"
                >
                  View All
                </div>
              </div>
            </div>
            <div class="offset-md-1"></div>
            <div
              class="col-sm-12 col-md-4 border shdw brdrad py-2 text-white bg-new"
            >
              <div class="row">
                <!-- <router-link to="/apiusers?type=new"> -->
                <div class="col-sm-12 text-center txt-grey py-4 text-white">
                  <h4>New Users</h4>
                </div>
                <!-- </router-link> -->
                <div class="col-sm-12 text-right pb-2 user-cnt">
                  <span class="h3">{{ newUserCnt }}</span> New signups
                  {{ day }}.
                </div>
                <table class="table table-striped text-center">
                  <thead>
                    <tr>
                      <th scope="col">User</th>
                      <!-- <th scope="col">Onboarding Date</th> -->
                      <th scope="col">Category</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="nUser in nUsers"
                      v-bind:key="nUser.user.aws_key.value"
                    >
                      <td class="cap" @click="navigate(nUser.user.aws_key.value)">
                        {{ nUser.user.name }}
                        <!-- {{nUsers}} -->
                      </td>
                      <!-- <td>{{ caseConversion1(nUser) }}</td> -->
                      <!-- <td>{{ getDate(nUser.user.aws_key.createdDate) }}</td> -->
                      <td>{{ caseConversion(nUser.category) }}</td>
                    </tr>
                  </tbody>
                </table>
                <div
                  class="col-sm-12 btn btn-sm text-center"
                  @click="getNewUsers()"
                >
                  View All
                </div>
              </div>
            </div>
          </div>
          <div class="row pt-5">
            <div class="offset-md-1"></div>
            <div
              class="col-sm-12 col-md-4 border shdw brdrad py-2 text-white bg-actv d-none"
            >
              <div class="row">
                <router-link to="/apiusers?type=latest">
                  <div
                    class="col-sm-12 text-center txt-grey py-4 text-white"
                    @click="getDetail('latest')"
                  >
                    <h4>Last Active Users</h4>
                  </div>
                </router-link>
                <table class="table table-striped text-center">
                  <thead>
                    <tr>
                      <th scope="col">User</th>
                      <th scope="col">Last call</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="lastUser in lastActiveUsers"
                      v-bind:key="lastUser.key"
                    >
                      <router-link :to="'/user/' + lastUser.key + '/info'">
                        <td class="cap">{{ lastUser.name }}</td>
                      </router-link>
                      <td>{{ getDate(lastUser.recentApiCall) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="offset-md-1"></div>
            <div
              class="col-sm-12 col-md-4 border shdw brdrad py-2 bg-grey d-none"
            >
              <div class="row">
                <div class="col-sm-12 text-center txt-grey py-4 text-white">
                  <h4>Inactive Users</h4>
                </div>
                <div class="col-sm-12 text-justify"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "./sidebar";
import Summary from "./Summary";
import moment from "moment";
import Apiusers from "./Apiusers";
import Timeframe from "./Timeframe";
import Userchart from "./Userchart";
import Paramdrpdwn from "./Paramdrpdwn";
import helpers from "../../mixins/helpers";

export default {
  name: "Dashboard",
  mounted() {
    this.filterObj = {
      custom:
        this.$route.query.custom && this.$route.query.custom == "true"
          ? true
          : false,
      days: this.$route.query.days ? this.$route.query.days : 1,
      from: this.$route.query.from || null,
      to: this.$route.query.to || null,
    };
    this.getCount();
  },
  data() {
    return {
      startDt: "",
      endDt: "",
      day: "today",
      mostApiCalls: [],
      lastActiveUsers: [],
      nUsers: [],
      newUserCnt: 0,
      allUserCnt: 0,
      usageHist: [],
      chartData: [],
      showHist: false,
      param: "",
      filterObj: {
        custom: false,
        days: 1,
      },
    };
  },
  mixins : [helpers],
  components: {
    Sidebar,
    Summary,
    Apiusers,
    Timeframe,
    Userchart,
    Paramdrpdwn,
  },
  methods: {
    caseConversion1(user) {
      console.log(user, 'all details are here')
    },
    getDayStr(n) {
      switch (n) {
        case "1":
          return "today";
          break;
        case "7":
          return "this week";
          break;
        case "30":
          return "this month";
          break;
        default:
          return "In the selected range";
      }
    },
    dateChanged(f) {
      this.filterObj.custom = f.custom;
      this.filterObj.days = f.num;
      this.filterObj.from = f.startDt;
      this.filterObj.to = f.endDt;
      this.$router.push({ path: "/apidb", query: this.filterObj });
    },
    getAPiUsage() {
      // const apiUri = `http://localhost:5000/dashboard/user-stats?start=${this.startDt}&end=${this.endDt}`;
      const apiUri = `http://13.235.254.91:5000/dashboard/user-stats?start=${this.startDt}&end=${this.endDt}`
      const options = {
        url: apiUri,
        method: "GET",
      };
      this.$http(options).then((result) => {
        console.log(result, apiUri, 'result is here, 1')
        this.mostApiCalls = result.data.mostApiCalls
        this.allUserCnt = result.data.allUserCnt;
        this.nUsers = result.data.newUsers;
        this.newUserCnt = result.data.newUserCnt;
      });
    },
    getUsageHist() {
      // const apiUri = `http://localhost:3002/dashboard/usage-history?start=${this.startDt}&end=${this.endDt}`;
      const apiUri = `http://13.235.254.91:5000/dashboard/usage-history?start=${this.startDt}&end=${this.endDt}`;
      const options = {
        url: apiUri,
        method: "GET",
      };
      this.$http(options).then((result) => {
        this.usageHist = result.data.data;
        this.setChartData("Total");
      });
    },
    async setChartData(param) {
      this.param = param;
      let chartData = await this.usageHist.filter((elm) => {
        return elm.category === param;
      }); 
      this.chartData = chartData.map((elm) => {
      return [elm.count,new Date(elm.createdAt).getTime()].reverse()
      }); 
    },
    getDetail(param) {
      this.$router.push({
        path: `/apiusers?type=${param}`,
        query: this.filterObj
      });
    },
    getNewUsers() {
      this.$router.push({
        path: `/nusers`,
        query: this.filterObj
      });
    },
    navigate(key) {
      this.$router.push({
        path: `/user/${key}/info`,
        query: this.filterObj,
      });
    },
    getCount() {
      this.day = this.getDayStr(this.filterObj.days);
      this.startDt = this.filterObj.from;
      this.endDt = this.filterObj.to;
      if(this.startDt && this.endDt)
      {
      this.getAPiUsage();
      }
      // this.getUsageHist();
      if (this.filterObj.days != 1) {
        this.showHist = true;
        this.getUsageHist();
      } else {
        this.showHist = false;
      }
    },
    getDate(dt) {
      return moment(dt).format("DD-MM-YYYY");
    },
  },
  watch: {
    $route() {
      this.filterObj = {
        custom:
          this.$route.query.custom && this.$route.query.custom == "true"
            ? true
            : false,
        days: this.$route.query.days ? this.$route.query.days : 1,
        from: this.$route.query.from || null,
        to: this.$route.query.to || null,
      };
      this.getCount();
    },
  },
};
</script>
<style scoped>
.mbox {
  height: 15rem;
}
.card-text {
  font-size: 2rem;
}
.bg-top {
  background-color: rgba(233, 30, 99, 0.8);
}
.bg-actv {
  background-color: rgba(34, 149, 200, 0.8);
}
.bg-new {
  background-color: rgba(40, 167, 69, 0.8);
}
.bg-grey {
  background-color: rgba(59, 59, 59, 0.8);
}
.hd {
  font-size: 1rem;
  font-weight: 500;
}
.cap:hover {
  color: #8b4513;
  cursor: pointer;
}
a {
  color: white;
  text-decoration: none;
  border-top: none;
}
.user-cnt {
  font-size: 0.87rem;
  font-weight: 500;
}
.table td,
.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: none;
}
</style>
